import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import App from "./App";
import PublicSubmit from "./components/PublicSubmit";
import LegalPage from "./components/LegalPage";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

function AppWithInvite() {
  const [params] = useSearchParams();
  return <App inviteToken={params.get("invite") || ""} />;
}

function PublicSubmitRoute() {
  const [params] = useSearchParams();
  return <PublicSubmit orgId={params.get("org")} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/submit" element={<PublicSubmitRoute />} />
        <Route path="/terms" element={<LegalPage />} />
        <Route path="/privacy" element={<LegalPage />} />
        <Route path="/eula" element={<LegalPage />} />
        <Route path="/security" element={<LegalPage />} />
        <Route path="/data-choices" element={<LegalPage />} />
        <Route path="/*" element={<AppWithInvite />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

serviceWorkerRegistration.register();
